export const productsKeys = {
  all: ['inventory-products'] as const,
  many: (queryProps?: Record<string, unknown>, type = 'list') =>
    [...productsKeys.all, type, ...[queryProps]].filter(Boolean),
  one: (id: number) => [...productsKeys.all, 'detail', id] as const,
};
